import axios from "axios";
import {Api} from "../services/configs";

export const QUESTIONNAIRE_QUESTIONS_LOADING = 'QUESTIONNAIRE_QUESTIONS_LOADING';
export const QUESTIONNAIRE_QUESTIONS_SUCCESS = 'QUESTIONNAIRE_QUESTIONS_SUCCESS';
export const QUESTIONNAIRE_QUESTIONS_ERROR = 'QUESTIONNAIRE_QUESTIONS_ERROR';

const headers = {
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
};

export const fetchQuestionnaireQuestions = (formVersion = 1) => async (dispatch) => {
  dispatch({ type: QUESTIONNAIRE_QUESTIONS_LOADING });
  try {
    const url = `${Api}/questionnaire?formVersion=${formVersion}`;
    const response = await axios.get(url);
    dispatch({ type: QUESTIONNAIRE_QUESTIONS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: QUESTIONNAIRE_QUESTIONS_ERROR, payload: error?.response?.data?.message || 'Failed to load questions' });
  }
};

export const submitQuestionnaire = (data, history, addToast, setLoading, onSuccess) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const url = `${Api}/questionnaire/submit`;
      const response = await axios.post(url, data, { headers });
      addToast(response.data?.message || 'Questionnaire submitted successfully', { appearance: 'success' });
      if (onSuccess) onSuccess();
    } catch (error) {
      addToast(error?.response?.data?.message || 'Something went wrong', { appearance: 'error' });
    } finally {
      setLoading(false);
    }
  };
};

export const getQuestionnaireQuestions = async (formVersion = 1, addToast) => {
  try {
    const url = `${Api}/questionnaire?formVersion=${formVersion}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    addToast(`${error?.response?.data?.message}`, { appearance: "error" });
    throw error;
  }
}

